import React, { useContext, useState } from 'react'
import { EngagementLetterContext } from './EngagementLetter'
import { Button, IconButton, Stack, TextField, Typography } from '@mui/material'
import CircleIcon from '@mui/icons-material/Circle'
import Delete from '@mui/icons-material/Delete'
import API from '../../../../services/API'
import { GlobalContext } from '../../../../App'

const CompanyObligations = () => {
  const { engagementLetter, setEngagementLetter } = useContext(
    EngagementLetterContext
  )
  const [newCompanyObligation, setNewCompanyObligation] = useState('')
  const { setToast } = useContext(GlobalContext)

  const handleSubmitNew = (e) => {
    e.preventDefault()
    API.put('/site-config', {
      'wordings.engagementLetter.companyObligations': [
        ...engagementLetter.companyObligations,
        newCompanyObligation,
      ],
    })
      .then((res) => {
        if (res.status === 200) {
          setToast({
            message: 'Engagement Letter Updated',
          })
          setNewCompanyObligation('')
          setEngagementLetter((prev) => ({
            ...prev,
            companyObligations: [
              ...prev.companyObligations,
              newCompanyObligation,
            ],
          }))
        }
      })
      .catch(() =>
        setToast({
          message: 'Unable to Update. Please try again later.',
          severity: 'error',
        })
      )
  }

  const handleDelete = (index) => {
    const newArray = [...engagementLetter.companyObligations]
    newArray.splice(index, 1)
    API.put('/site-config', {
      'wordings.engagementLetter.companyObligations': newArray,
    })
      .then((res) => {
        if (res.status === 200) {
          setToast({ message: 'Engagement Letter Updated' })
          setEngagementLetter((prev) => ({
            ...prev,
            companyObligations: newArray,
          }))
        }
      })
      .catch(() =>
        setToast({
          message: 'Unable to Update. Please try again later.',
          severity: 'error',
        })
      )
  }

  return (
    <Stack>
      <Typography variant="title3">Company Obligations</Typography>
      <Typography variant="caption">The Medical Provider will...</Typography>
      <ul>
        {engagementLetter.companyObligations.map((x, i) => (
          <li key={i}>
            <Stack
              direction="row"
              justifyContent="space-between"
              gap={0.5}
              alignItems="center"
            >
              <Typography>{x}</Typography>
              <Button>
                <Delete color="error" onClick={() => handleDelete(i)}/>
              </Button>
            </Stack>
          </li>
        ))}
      </ul>
      <Stack
        direction={{ xs: 'column', lg: 'row' }}
        gap={1}
        component="form"
        onSubmit={handleSubmitNew}
      >
        <TextField
          value={newCompanyObligation}
          onChange={(e) => setNewCompanyObligation(e.target.value)}
          fullWidth
          label="Add a new Company Obligation"
          autoComplete="off"
          required
        />
        <Button
          disabled={!newCompanyObligation}
          variant="contained"
          color="success"
          type="submit"
        >
          Submit
        </Button>
      </Stack>
    </Stack>
  )
}

export default CompanyObligations
